export const RODRI_WEB = "https://www.rodrigohernanlopez.com.ar/";
export const DEVS_NAME = "Rodrigo Hernán López";
